<template>
  <div class="product">
    <p class="title">产品体系</p>
    <ul class="product-box">
      <li v-for="(item, index) in contentArr" :key="index" @click="toUrl(item.url)">
        <img :src="item.img" alt="">
        <p class="product-label">{{item.label}}</p>
        <p>{{item.content}}</p>
        <p>......</p>
      </li>
    </ul>
  </div>
</template>

<script>
import i1 from '../../assets/images/product/1.png'
import i2 from '../../assets/images/product/2.png'
import i3 from '../../assets/images/product/3.png'
import i4 from '../../assets/images/product/4.png'
import i5 from '../../assets/images/product/5.png'
import i6 from '../../assets/images/product/6.png'
export default {
  data () {
    return {
      contentArr: [
        {url: '/saas', img: i1, label: '场地管理SaaS云平台', content: '聚焦线下实体门店智能化改造与系统升级提升门店数字化运营水平'},
        {url: '/dataCenter', img: i2, label: '数据中台', content: '全力挖掘数据价值，赋能中小系统开发商和行业龙头企业，帮助其产品快'},
        {url: '/association', img: i3, label: '物联平台', content: '包含设备监控与分润系统，聚焦设备资产智能运营'},
        {url: '/briefing', img: i4, label: '智绘简报', content: '优化传统系统的数据报表模式,实现数据共享、多维度分析、可'},
        {url: '/payment', img: i5, label: '聚合支付', content: '智绘收款平台定制化支付解决方案助力中小企业、支付无忧'},
        {url: '/monitor', img: i6, label: '客流监控', content: '运用人脸AI识别技术，实时监控到店进店与出店频次，新客与熟客占比'}
      ]
    }
  },
  methods: {
    toUrl (url) {
      if (url && url !== this.$route.path) {
        this.$router.push(url)
      }
    }
  }
}
</script>
<style scoped>
  .product{
    padding: 110px 360px;
  }
  .title{
    font-size:34px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:60px;
    color:rgba(51,51,51,1);
    margin-bottom: 90px;
  }
  .product-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .product-box>li{
    width: 375px;
    height: 375px;
    padding: 60px 28px 30px;
    box-sizing: border-box;
    background:rgba(229,238,255,0.1);
    border:1px solid rgba(229,238,255,1);
    margin-bottom: 38px;
    cursor: pointer;
    transition: all 0.5s;
  }
  .product-box>li p {
    color:rgba(102,102,102,1);
    font-size:18px;
    font-family:PingFang SC;
  }
  .product-box>li .product-label{
    color:rgba(51,51,51,1);
    margin-bottom: 24px;
    font-weight:bold;
    font-size:20px;
  }
  .product-box>li img{
    width: 100px;
    margin-bottom: 40px;
  }
  .product-box>li:hover{
    background:rgba(253,254,255,1);
    border:1px solid rgba(229,238,255,1);
    box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  }
</style>



// WEBPACK FOOTER //
// src/components/home/product.vue